import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Items from "@components/items";
import { useSelector } from "react-redux";
import SubCategoryMenu from "@components/sub-category-menu";
import { Typography } from "@mui/material";

function Menu(props) {
  const { isLoading, error } = useSelector((state) => state.menu);

  if (isLoading) {
    return "Loading";
  }

  if (error) {
    return "Error";
  }

  return (
    <div>
      <SubCategoryMenu />
    </div>
  );
}

Menu.propTypes = {};

export default Menu;
